import {Component, Input, OnDestroy} from "@angular/core";
import {Subject, timer} from "rxjs";
import {debounce, distinctUntilChanged} from "rxjs/operators";

@Component({
    selector: "pcg-ng-spinner",
    template: require('./spinner.component.html')
})
export class SpinnerComponent implements OnDestroy {
    public state: boolean;

    private stateSubject = new Subject<boolean>();

    public get show(): boolean {
        return this.state;
    }

    @Input()
    public set show(state: boolean) {
        this.stateSubject.next(Boolean(state));
    }

    @Input()
    public size: "large" | "medium" | "small" = "large";

    public constructor() {
        this.stateSubject
            .pipe(
                debounce(state => timer(state ? 250 : 0)),
                distinctUntilChanged()
            )
            .subscribe(state => this.state = state);
    }

    public ngOnDestroy(): void {
        this.stateSubject.complete();
    }
}
